var _desc, _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11Lead(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1.1 lead") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.84232922,17 L15.596118,17 L15.596118,17 C18.0192954,17 20.1315167,18.6491726 20.7192236,21 L21.4085897,23.7574644 L21.4085897,23.7574644 C21.5425384,24.2932593 21.2167777,24.8361938 20.6809828,24.9701425 C20.6016622,24.9899727 20.520209,25 20.4384472,25 L1,25 L1,25 C0.44771525,25 -2.12486467e-14,24.5522847 -2.13162821e-14,24 C-2.1326295e-14,23.9182382 0.0100273489,23.836785 0.0298574999,23.7574644 L0.719223594,21 L0.719223594,21 C1.30693044,18.6491726 3.4191518,17 5.84232922,17 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,13 L15,13 L15,18 C13.2548345,19 11.9215011,19.5 11,19.5 C10.0784989,19.5 8.74516554,19 7,18 L7,13 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55137038,11.6666667 C3.56544855,6 4.39291598,2.5 8.03377265,1.16666667 C11.6746293,-0.166666667 13.8300384,0.277777778 14.5,2.5 C17.4708951,2.94444444 18.2943687,5.33333333 16.9704208,9.66666667",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77377432,16.8641429 C7.04816281,16.2509607 5,13.6345996 5,10.5 C5,8.47893901 6.5,5 9.5,6 C11.5,6.66666667 13,6.16666667 14,4.5 C16,6.10676608 17,8.10676608 17,10.5 C17,13.6345996 14.9518372,16.2509607 12.2262257,16.8641429 C11.9546565,17.2487971 11.5066641,17.5 11,17.5 C10.4933359,17.5 10.0453435,17.2487971 9.77377432,16.8641429 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84232922,17 L15.596118,17 L15.596118,17 C18.0192954,17 20.1315167,18.6491726 20.7192236,21 L21.4085897,23.7574644 L21.4085897,23.7574644 C21.5425384,24.2932593 21.2167777,24.8361938 20.6809828,24.9701425 C20.6016622,24.9899727 20.520209,25 20.4384472,25 L1,25 L1,25 C0.44771525,25 -2.12486467e-14,24.5522847 -2.13162821e-14,24 C-2.1326295e-14,23.9182382 0.0100273489,23.836785 0.0298574999,23.7574644 L0.719223594,21 L0.719223594,21 C1.30693044,18.6491726 3.4191518,17 5.84232922,17 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,13 L15,13 L15,18 C13.2548345,19 11.9215011,19.5 11,19.5 C10.0784989,19.5 8.74516554,19 7,18 L7,13 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55137038,11.6666667 C3.56544855,6 4.39291598,2.5 8.03377265,1.16666667 C11.6746293,-0.166666667 13.8300384,0.277777778 14.5,2.5 C17.4708951,2.94444444 18.2943687,5.33333333 16.9704208,9.66666667",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77377432,16.8641429 C7.04816281,16.2509607 5,13.6345996 5,10.5 C5,8.47893901 6.5,5 9.5,6 C11.5,6.66666667 13,6.16666667 14,4.5 C16,6.10676608 17,8.10676608 17,10.5 C17,13.6345996 14.9518372,16.2509607 12.2262257,16.8641429 C11.9546565,17.2487971 11.5066641,17.5 11,17.5 C10.4933359,17.5 10.0453435,17.2487971 9.77377432,16.8641429 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79610077,19.6153846 L18.5402459,19.6153846 L18.5402459,19.6153846 C21.3437244,19.6153846 23.7909313,21.5149126 24.4863552,24.2307692 L25.348595,27.5980963 L25.348595,27.5980963 C25.4855934,28.1331196 25.1629304,28.6779008 24.6279072,28.8148992 C24.5468544,28.8356536 24.4635174,28.8461538 24.3798497,28.8461538 L0.956497008,28.8461538 L0.956497008,28.8461538 C0.404212258,28.8461538 -0.0435029917,28.3984386 -0.0435029917,27.8461538 C-0.0435029917,27.7624861 -0.033002714,27.6791491 -0.0122482995,27.5980963 L0.84999152,24.2307692 L0.84999152,24.2307692 C1.54541542,21.5149126 3.99262224,19.6153846 6.79610077,19.6153846 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27272727,15 L17.7272727,15 L17.7272727,20.7692308 C15.6648044,21.9230769 14.0890468,22.5 13,22.5 C11.9109532,22.5 10.3351956,21.9230769 8.27272727,20.7692308 L8.27272727,15 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56071044,13.4615385 C4.21371193,6.92307692 5.19162798,2.88461538 9.49445859,1.34615385 C13.7972892,-0.192307692 16.3445909,0.320512821 17.1363636,2.88461538 C20.6474215,3.3974359 21.6206176,6.15384615 20.0559519,11.1538462",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5508242,19.4586264 C8.32964696,18.7511085 5.90909091,15.7322303 5.90909091,12.1153846 C5.90909091,9.78339116 7.68181818,5.76923077 11.2272727,6.92307692 C13.5909091,7.69230769 15.3636364,7.11538462 16.5454545,5.19230769 C18.9090909,7.04626856 20.0909091,9.35396087 20.0909091,12.1153846 C20.0909091,15.7322303 17.670353,18.7511085 14.4491758,19.4586264 C14.1282304,19.9024581 13.5987848,20.1923077 13,20.1923077 C12.4012152,20.1923077 11.8717696,19.9024581 11.5508242,19.4586264 Z",
    id: "path-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-lead"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.300000012,
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M5.84232922,17.5 C3.64858562,17.5 1.73635582,18.9930239 1.20429484,21.1212678 L0.51492875,23.8787322 C0.505013674,23.9183925 0.5,23.9591191 0.5,24 C0.5,24.2761424 0.723857625,24.5 1,24.5 L20.4384472,24.5 C20.4793281,24.5 20.5200547,24.4949863 20.559715,24.4850713 C20.8276125,24.4180969 20.9904928,24.1466296 20.9235184,23.8787322 L20.2341523,21.1212678 C19.7020914,18.9930239 17.7898616,17.5 15.596118,17.5 L5.84232922,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M7.5,13.5 L7.5,17.7083167 C9.05095962,18.573065 10.2285262,19 11,19 C11.7714738,19 12.9490404,18.573065 14.5,17.7083167 L14.5,13.5 L7.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M5.886213,11.1004093 L16.5794116,9.22753924 C17.7030268,5.34270252 16.9661798,3.37450333 14.4260235,2.99449719 L14.1127232,2.94762762 L14.0212827,2.644325 C13.4557359,0.768440459 11.6128383,0.388435752 8.20571269,1.63617345 C4.95715418,2.82584164 4.1559241,5.90338671 5.886213,11.1004093 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#EEF1F9",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M14.1019151,5.24271288 C12.9783815,6.72706545 11.3536642,7.14493435 9.34188612,6.47434165 C7.20315941,5.76143275 5.5,8.02633359 5.5,10.5 C5.5,13.3658426 7.354725,15.8074314 9.88351673,16.3763349 L10.0712514,16.4185697 L10.1822339,16.5757669 C10.3688891,16.8401478 10.6705908,17 11,17 C11.3294092,17 11.6311109,16.8401478 11.8177661,16.5757669 L11.9287486,16.4185697 L12.1164833,16.3763349 C14.645275,15.8074314 16.5,13.3658426 16.5,10.5 C16.5,8.4324564 15.7075213,6.68956689 14.1019151,5.24271288 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 0.300000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M5.84232922,17.5 C3.64858562,17.5 1.73635582,18.9930239 1.20429484,21.1212678 L0.51492875,23.8787322 C0.505013674,23.9183925 0.5,23.9591191 0.5,24 C0.5,24.2761424 0.723857625,24.5 1,24.5 L20.4384472,24.5 C20.4793281,24.5 20.5200547,24.4949863 20.559715,24.4850713 C20.8276125,24.4180969 20.9904928,24.1466296 20.9235184,23.8787322 L20.2341523,21.1212678 C19.7020914,18.9930239 17.7898616,17.5 15.596118,17.5 L5.84232922,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M7.5,13.5 L7.5,17.7083167 C9.05095962,18.573065 10.2285262,19 11,19 C11.7714738,19 12.9490404,18.573065 14.5,17.7083167 L14.5,13.5 L7.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M5.886213,11.1004093 L16.5794116,9.22753924 C17.7030268,5.34270252 16.9661798,3.37450333 14.4260235,2.99449719 L14.1127232,2.94762762 L14.0212827,2.644325 C13.4557359,0.768440459 11.6128383,0.388435752 8.20571269,1.63617345 C4.95715418,2.82584164 4.1559241,5.90338671 5.886213,11.1004093 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#EEF1F9",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M14.1019151,5.24271288 C12.9783815,6.72706545 11.3536642,7.14493435 9.34188612,6.47434165 C7.20315941,5.76143275 5.5,8.02633359 5.5,10.5 C5.5,13.3658426 7.354725,15.8074314 9.88351673,16.3763349 L10.0712514,16.4185697 L10.1822339,16.5757669 C10.3688891,16.8401478 10.6705908,17 11,17 C11.3294092,17 11.6311109,16.8401478 11.8177661,16.5757669 L11.9287486,16.4185697 L12.1164833,16.3763349 C14.645275,15.8074314 16.5,13.3658426 16.5,10.5 C16.5,8.4324564 15.7075213,6.68956689 14.1019151,5.24271288 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M6.79610077,20.1153846 C4.22099483,20.1153846 1.97313854,21.8601762 1.33436417,24.354798 L0.472124354,27.7221251 C0.461747147,27.7626515 0.456497008,27.80432 0.456497008,27.8461538 C0.456497008,28.1222962 0.680354633,28.3461538 0.956497008,28.3461538 L24.3798497,28.3461538 C24.4216835,28.3461538 24.4633521,28.3409037 24.5038784,28.3305265 C24.7713901,28.2620273 24.9327215,27.9896367 24.8642223,27.7221251 L24.0019825,24.354798 C23.3632081,21.8601762 21.1153518,20.1153846 18.5402459,20.1153846 L6.79610077,20.1153846 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M8.77272727,15.5 L8.77272727,20.4743972 C10.6400511,21.4950307 12.0599241,22 13,22 C13.9400759,22 15.3599489,21.4950307 17.2272727,20.4743972 L17.2272727,15.5 L8.77272727,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D0DAEF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M6.89248842,12.8975467 L19.6679427,10.7129383 C21.0268762,6.1613078 20.1429985,3.82906568 17.064101,3.37936594 L16.7517557,3.33374519 L16.658622,3.03213789 C15.9731686,0.81234364 13.7335775,0.361471132 9.66279527,1.8169646 C5.75590315,3.21385976 4.80594925,6.82660331 6.89248842,12.8975467 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#EEF1F9",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B5A98",
    strokeWidth: 1,
    d: "M16.6514616,5.92662637 C15.345296,7.6745693 13.4470909,8.1713151 11.0725389,7.3985319 C8.46335084,6.54938787 6.40909091,9.21653228 6.40909091,12.1153846 C6.40909091,15.4546132 8.6263466,18.3043583 11.6580901,18.9702679 L11.8442848,19.0111648 L11.9559903,19.1656411 C12.1926854,19.4929641 12.5780432,19.6923077 13,19.6923077 C13.4219568,19.6923077 13.8073146,19.4929641 14.0440097,19.1656411 L14.1557152,19.0111648 L14.3419099,18.9702679 C17.3736534,18.3043583 19.5909091,15.4546132 19.5909091,12.1153846 C19.5909091,9.67703985 18.6189839,7.62415152 16.6514616,5.92662637 Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11Lead);
export default __webpack_public_path__ + "static/media/1_1_lead.e2083468f9dd394517fabc40ea3dd826.svg";
export { ForwardRef as ReactComponent };